import React from "react";
import ReactLoading from "react-loading";
import PropTypes from "prop-types";

function Loader(props) {
  const { type, color, className, visible } = { ...props };
  if (!visible) return null;
  return <ReactLoading type={type} color={color} className={className} />;
}

export default Loader;

Loader.defaultProps = {
  type: "balls",
  color: "#ffc500",
  className: "",
  visible: false,
};

Loader.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  visible: PropTypes.bool,
};
